import { render, staticRenderFns } from "./ChatFiltersNewAnimation.vue?vue&type=template&id=6b4a5e24&scoped=true&"
import script from "./ChatFiltersNewAnimation.vue?vue&type=script&lang=ts&"
export * from "./ChatFiltersNewAnimation.vue?vue&type=script&lang=ts&"
import style0 from "./ChatFiltersNewAnimation.vue?vue&type=style&index=0&id=6b4a5e24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4a5e24",
  null
  
)

export default component.exports